import React from 'react'
import { graphql, Link } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Header from '@layouts/header'
import Layout from '@layouts/layout'
import ArticlePreview from '@components/article-preview/article-preview'
import NotesPreview from '@components/notes-preview/notes-preview'
import './index.scss'

class RootIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const posts = get(this, 'props.data.allContentfulBlogPost.edges')
    const notes = get(this, 'props.data.allMarkdownRemark.edges')

    return (
      <Layout location={this.props.location}>
        <div>
          <Helmet title={siteTitle} />
          <Header />
          <div className="latest-notes wrapper">
            <div className="box-shadow latest-notes__card">
              <h1 className="section-headline">Jurnal teknis</h1>
              <ul>
                {notes.map(({ node }) => (
                  <li key={node.fields.title}>
                    <NotesPreview
                      title={node.fields.title}
                      excerpt={node.fields.description}
                      slug={`/notes/${node.fields.slug}`}
                    />
                  </li>
                ))}
              </ul>
              <Link className="link__blue" to="/notes/">
                Lihat semua jurnal teknis...
              </Link>
            </div>
          </div>
          <div className="wrapper">
            <h1 className="section-headline">Artikel terbaru</h1>
            <ul className="article-list grid">
              {posts.map(({ node }) => {
                return (
                  <li key={node.slug}>
                    <ArticlePreview article={node} />
                  </li>
                )
              })}
            </ul>
            <Link className="link__blue" to="/blog/">
              Lihat semua artikel...
            </Link>
          </div>
        </div>
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogPost(sort: { fields: [publishDate], order: DESC }, limit: 3) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/notes/" } }
      sort: { fields: frontmatter___date, order: DESC }
      limit: 3
    ) {
      edges {
        node {
          fields {
            title
            slug
            description
          }
          excerpt
        }
      }
    }
  }
`
